import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  subtext?: string;
  variant?: 'gold' | 'outline';
};
export function CTAButton({
  label,
  subtext,
  variant = 'gold'
}: CTAButtonProps) {
  const base = 'group flex w-full items-center justify-center gap-2 rounded-xl px-5 py-4 text-center font-display text-lg font-700 uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-200 ease-out focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold-400/50 active:scale-[0.985] sm:text-xl';
  const styles = variant === 'gold' ? 'bg-gold-500 text-navy-950 shadow-[0_10px_30px_-10px_rgba(212,162,78,0.7)] hover:bg-gold-400' : 'border-2 border-gold-500 bg-transparent text-gold-400 hover:bg-gold-500 hover:text-navy-950';
  return <div className="w-full" data-id="element-95" data-mp="38oshz3auccvb">
      <a href={CHECKOUT_URL} className={`${base} ${styles}`} data-id="element-96" data-mp="38pk13en94i4p">
        <span data-id="element-97" data-mp="1996cl2iajzcx">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-98" data-mp="199y5u6of1l01" />
      </a>
      {subtext ? <p className="mt-3 text-center text-[11px] font-medium uppercase tracking-wider text-slate-400 sm:text-xs" data-id="element-99" data-mp="1i8joe1tw100t">
          {subtext}
        </p> : null}
    </div>;
}